import axios from 'axios'
import {
  contentTypeInterceptor,
  csrfTokenInterceptor,
  parseErrorInterceptor,
  removeEmptyRequestDataInterceptor
} from './inspectors'

const client = axios.create()
client.interceptors.request.use(csrfTokenInterceptor)
client.interceptors.request.use(contentTypeInterceptor)
client.interceptors.request.use(removeEmptyRequestDataInterceptor)
client.interceptors.response.use(response => response, parseErrorInterceptor)

export default class ApiClient {
  static get(url, options) {
    return this.request(url, 'GET', null, options)
  }

  static post(url, data = null, options = null) {
    return this.request(url, 'POST', data, options)
  }

  static put(url, data = null, options) {
    return this.request(url, 'PUT', data, options)
  }

  static patch(url, data = null, options) {
    return this.request(url, 'PATCH', data, options)
  }

  static delete(url, data = null, options) {
    return this.request(url, 'DELETE', data, options)
  }

  static request(url, method, data = null, options = null) {
    const extraOptions = { ...options }
    const config = {
      method,
      url,
      headers: {
        ...extraOptions.headers
      },
      data
    }

    // キャンセル用の処理
    if (extraOptions.source) {
      config.cancelToken = extraOptions.source.token
    }

    return client(config)
  }
}
